import { PRIMARY_TIME_ZONES } from "../../../../../../config/constant";
import DomainConfig from "../config";

const { MODEL_FIELDS, FIELD_TYPE, FIELD_LEVEL } = DomainConfig;

const FormModel = {
  [MODEL_FIELDS.adCreatedRange]: {
    fieldName: MODEL_FIELDS.adCreatedRange,
    fieldType: FIELD_TYPE.dateRangeSelectorFilter,
    mapping: { fromDate: "createdAtFrom", toDate: "createdAtTo" },
    label: "ad created date",
    elementId: "ad-created-range",
  },
  [MODEL_FIELDS.adFirstPublishedRange]: {
    fieldName: MODEL_FIELDS.adFirstPublishedRange,
    fieldType: FIELD_TYPE.dateRangeSelectorFilter,
    label: "ad first publish date",
    elementId: "ad-first-publish-range",
  },
  [MODEL_FIELDS.adLastPublishedRange]: {
    fieldName: MODEL_FIELDS.adLastPublishedRange,
    fieldType: FIELD_TYPE.dateRangeSelectorFilter,
    label: "ad lastest publish date",
    elementId: "ad-last-publish-range",
  },
  [MODEL_FIELDS.adExpriedRange]: {
    fieldName: MODEL_FIELDS.adExpriedRange,
    fieldType: FIELD_TYPE.dateRangeSelectorFilter,
    label: "ad expire date",
    elementId: "ad-expire-range",
  },
  [MODEL_FIELDS.pricingTier]: {
    fieldName: MODEL_FIELDS.pricingTier,
    fieldType: FIELD_TYPE.multiSelectFilterInput,
    label: "package",
    elementId: "package-selector",
    options: [
      { value: "1m", label: "1m" },
      { value: "2m", label: "2m" },
      { value: "3m", label: "3m" },
      { value: "1m_basic", label: "1m Basic" },
      { value: "2m_basic", label: "2m Basic" },
      { value: "3m_basic", label: "3m Basic" },
      { value: "3m_pro", label: "3m Pro" },
      { value: "6m_vip", label: "Premium" },
    ],
  },
  [MODEL_FIELDS.profileStatus]: {
    fieldName: MODEL_FIELDS.profileStatus,
    fieldType: FIELD_TYPE.multiSelectFilterInput,
    label: "post status",
    elementId: "profile-status-selector",
    options: [
      { value: "PAYMENT_PENDING", label: "Payment Pending" },
      { value: "INCOMPLETE", label: "Incomplete" },
      { value: "IN_REVIEW", label: "In Review" },
      { value: "LIVE", label: "Live" },
      { value: "EXPIRED", label: "Expired" },
      { value: "DISABLED", label: "Disabled" },
    ],
  },
  [MODEL_FIELDS.subscriptionStatus]: {
    fieldName: MODEL_FIELDS.subscriptionStatus,
    fieldType: FIELD_TYPE.multiSelectFilterInput,
    label: "subscription status",
    elementId: "subscription-status-selector",
    options: [
      { value: "NOT_STARTED", label: "Not Started" },
      { value: "STARTED", label: "Started" },
      { value: "GRACE_PERIOD", label: "Grace Period" },
      { value: "RENEWED", label: "Renewed" },
      { value: "RENEW_FAILED", label: "Renew Failed" },
      { value: "USER_CANCELLED", label: "User Cancelled" },
      { value: "SYSTEM_CANCELLED", label: "System Cancelled" },
      { value: "ADMIN_CANCELLED", label: "Admin Cancelled" },
    ],
  },
  sortOrder: {
    fieldName: MODEL_FIELDS.sortOrder,
    fieldType: FIELD_TYPE.combinedSelectInput,
    label: "Sort Order",
    elementId: "sort-order-selector",
    fields: [
      {
        fieldName: MODEL_FIELDS.sortBy,
        fieldType: FIELD_TYPE.SingleSelectFilterInput,
        fieldLevel: FIELD_LEVEL.primary,
        label: "Sort By",
        elementId: "sort-by-selector",
        options: [
          { value: "createdAt", label: "Created At" },
          { value: "firstPublishedAt", label: "First Published At" },
          { value: "latestPublishedAt", label: "Latest Published At" },
          { value: "expiredAt", label: "Expired At" },
        ],
      },
      {
        fieldName: MODEL_FIELDS.sortDirection,
        fieldType: FIELD_TYPE.SingleSelectFilterInput,
        fieldLevel: FIELD_LEVEL.secondary,
        label: "Sort Direction",
        elementId: "sort-direction-selector",
        options: [
          { value: "asc", label: "Asc" },
          { value: "desc", label: "Desc" },
        ],
      },
    ],
  },
  [MODEL_FIELDS.residentCountry]: {
    fieldName: MODEL_FIELDS.residentCountry,
    fieldType: FIELD_TYPE.multiSelectFilterInput,
    label: "Resident Country",
    elementId: "resident-country-selector",
    options: [
      {
        value: "AU",
        label: "Australia",
      },
      {
        value: "CA",
        label: "Canada",
      },
      {
        value: "GB",
        label: "United Kingdom",
      },
      {
        value: "IT",
        label: "Italy",
      },
      {
        value: "JP",
        label: "Japan",
      },
      {
        value: "LK",
        label: "Sri Lanka",
      },
      {
        value: "MV",
        label: "Maldives",
      },
      {
        value: "NZ",
        label: "New Zealand",
      },
      {
        value: "US",
        label: "United States",
      },
      {
        value: "ZZ",
        label: "Other Countries",
      },
    ],
  },
  [MODEL_FIELDS.timeZone]: {
    fieldName: MODEL_FIELDS.timeZone,
    label: "Time Zone",
    defaultValue: PRIMARY_TIME_ZONES.UTC,
    options: [
      {
        id: PRIMARY_TIME_ZONES.UTC,
        label: PRIMARY_TIME_ZONES.UTC,
        value: PRIMARY_TIME_ZONES.UTC,
        default: true,
      },
      {
        id: PRIMARY_TIME_ZONES.ASIA_COLOMBO,
        label: PRIMARY_TIME_ZONES.ASIA_COLOMBO,
        value: PRIMARY_TIME_ZONES.ASIA_COLOMBO,
      },
      {
        id: PRIMARY_TIME_ZONES.AUSTRALIA_MELBOURNE,
        label: PRIMARY_TIME_ZONES.AUSTRALIA_MELBOURNE,
        value: PRIMARY_TIME_ZONES.AUSTRALIA_MELBOURNE,
      },
    ],
  },
};
export default FormModel;
